import React, { useState } from 'react';
import { api, auth } from '../api/client';

export default function ResetPin({ onDone }) {
  const [pin, setPin] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit() {
    setError('');
    if (!/^\d{4}$/.test(pin)) { setError('PIN must be exactly 4 digits.'); return; }
    if (pin === '1234') { setError('Please choose a PIN other than 1234.'); return; }
    if (pin !== confirm) { setError('PINs do not match.'); return; }
    setBusy(true);
    try {
      await api.resetPin(pin);
      auth.patchUser({ mustResetPin: false });
      onDone();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app-shell">
      <div className="center-stack">
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <h1>Set your PIN</h1>
          <p className="muted">For security, choose a new 4-digit PIN to replace the default.</p>
        </div>
        <div className="card">
          <div className="field">
            <label className="label">New PIN</label>
            <input className="input pin-input" type="password" inputMode="numeric"
              maxLength={4} placeholder="••••" value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))} />
          </div>
          <div className="field">
            <label className="label">Confirm PIN</label>
            <input className="input pin-input" type="password" inputMode="numeric"
              maxLength={4} placeholder="••••" value={confirm}
              onChange={(e) => setConfirm(e.target.value.replace(/\D/g, ''))} />
          </div>
          <button className="btn btn-primary" disabled={busy} onClick={submit}>
            {busy ? <span className="spinner" /> : 'Save PIN'}
          </button>
          {error && <p className="error-text">{error}</p>}
        </div>
      </div>
    </div>
  );
}
